import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button, Form, InputGroup } from "react-bootstrap";
import apiService from '../../services/api.services';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import { toast } from "react-toastify";

function CostSheetApproval() {
    const [series, setSeries] = useState("");
    const [approvalid, setApprovalid] = useState("");

    let { approvalRole } = useParams();
  
    const { encParam } = useParams();
    // approvalRole,
    const [approvalReq, setApprovalReq] = useState("");
    const [MgmtapprovalReq, setMgmtApprovalReq] = useState("");
    
    const [response, setResponse] = useState("");
    const [showThankYou, setShowThankYou] = useState(false);
    const [mgmtResponse, setMgmtResponse] = useState("");
    const [showMGMTThankYou, setShowMGMTThankYou] = useState(false);
    const [rejectionMessage, setRejectionMessage] = useState("");
    const [approvalMessage, setApprovalMessage] = useState("");
    const [appvCIMessage, setAppvCIMessage] = useState("");
    const [ciMgmtReason, setCIMgmtReason] = useState("");
    const [mgmtApprovalRequire, setMgmtApprovalRequire] = useState("");
    const [mgmtApprovalMessage, setMgmtApprovalMessage] = useState("");
    const [mgmtRejectionMessage, setMgmtRejectionMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();


    useEffect(() => {

      try {
        const decoded = jwt_decode(encParam);
          console.log("Decrypted:", decoded);
          setSeries(decoded.formseriesSent);
          setApprovalid(decoded.approvalidSent);
          window.sessionStorage.setItem('ApproversEmpId',decoded.approvalidSent);

          console.log('approvalRole>>>>>',approvalRole)
        
        const formseriesSent = decoded.formseriesSent;
        const approvalidSent= decoded.approvalidSent;
        const approvalRoleSent= decoded.approvalRoleSent;

        apiService.confirmedENTCSAppv(decoded.formseriesSent).then((response) => {
          
          const status = response.data.appvStatus;
          console.log('response.data',response.data);
          console.log('response.data.status',status);
          const ApproversEmpId = window.sessionStorage.getItem('ApproversEmpId');

          if(status.appvCreditInsuranceStatus === "Management Approval"){
            setMgmtApprovalRequire("YES")
            setCIMgmtReason(status.appvCreditInsuranceMessage)
          }


          if (approvalRole === "TEAM LEADER") {
            setApprovalReq("YES")
            // const tlDone = ApproversEmpId === status.appvTeamLeaderID && (status.appvTeamLeaderStatus === "Approved" || status.appvTeamLeaderStatus === "Rejected");
            // const bhDone = ApproversEmpId === status.appvBranchHeadID && (status.appvBranchHeadStatus === "Approved" || status.appvBranchHeadStatus === "Rejected");
            // const rbhDone = ApproversEmpId === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected");

            const tlDone = approvalid === status.appvTeamLeaderID && (status.appvTeamLeaderStatus !== "Pending");
            const bhDone = approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus !== "Pending");
            const rbhDone = approvalid === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus !== "Pending");

            // if(tlDone || bhDone || rbhDone ){
            //   setApprovalReq("YES")
            // }

            const tlCheck = !status.appvTeamLeaderID || status.appvTeamLeaderID !== ApproversEmpId || tlDone;
            const bhCheck = !status.appvBranchHeadID || status.appvBranchHeadID !== ApproversEmpId || bhDone;
            const rbhCheck = !status.appvRegionBusinessHeadID || status.appvRegionBusinessHeadID !== ApproversEmpId || rbhDone;

            const allAssignedRolesDone = tlCheck && bhCheck && rbhCheck;        
            console.log(
              `ApproversEmpId ${ApproversEmpId},
              tlId: ${status.appvTeamLeaderID},
              bhId: ${status.appvBranchHeadID},
              rbhId: ${status.appvRegionBusinessHeadID},
              tlDone ${tlDone},
              bhDone ${bhDone},
              rbhDone ${rbhDone},
              tlCheck ${tlCheck},
              bhCheck ${bhCheck},
              rbhCheck ${rbhCheck},
              allAssignedRolesDone${allAssignedRolesDone}
            `);
          
            if (allAssignedRolesDone) {
              
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }

            // if(status.mgmtAppvRegionBusinessHeadReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if((status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected")){
                    setMgmtResponse("Your Management Approval is already recorded for this Deal!");
                    setShowMGMTThankYou(true);
            }
          } else if ( approvalRole === "BRANCH HEAD") {
            // && (status.appvBranchHeadStatus === "Approved" ||status.appvBranchHeadStatus === "Rejected")
            if(status.appvBranchHeadReq === "YES"){
                setApprovalReq("YES")
            }
            if (status.appvBranchHeadStatus !== "Pending") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            // setResponse("Your approval is already recorded for this Deal!");
            // setShowThankYou(true);
            
          } else if (approvalRole === "REGION BUSINESS HEAD") {
            if(status.appvRegionBusinessHeadReq === "YES"){
                setApprovalReq("YES")
            }
            // if(status.mgmtAppvRegionBusinessHeadReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if (status.appvRegionBusinessHeadStatus !== "Pending") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            if (status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected") {
              setMgmtResponse("Your Management Approval is already recorded for this Deal!");
              setShowMGMTThankYou(true);
            }
          } else if (approvalRole === "BUSINESS FINANCE") {
            
            setTimeout(() => {
              if(status.appvBusinessFinanceReq === "YES"){
                setApprovalReq("YES")
            }
            }, 3000);
            
            // if(status.mgmtAppvBusinessFinanceReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if (status.appvBusinessFinanceStatus === "Approved" || status.appvBusinessFinanceStatus === "Rejected") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            if (status.mgmtAppvBusinessFinanceStatus === "Approved" || status.mgmtAppvBusinessFinanceStatus === "Rejected") {
              setMgmtResponse("Your Management Approval is already recorded for this Deal!");
              setShowMGMTThankYou(true);
            }
          } else if ( approvalRole === "EXPORT COMPLIANCE") {
            if(status.appvExportComplianceReq === "YES"){
                setApprovalReq("YES")
            }
            //  && (status.appvExportComplianceStatus === "Approved" || status.appvExportComplianceStatus === "Rejected")
            if (status.appvExportComplianceStatus !== "Pending") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
          } else if ( approvalRole === "CREDIT INSURANCE") {
            if(status.appvCreditInsuranceReq === "YES"){
                setApprovalReq("YES")
            }
            // && (status.appvCreditInsuranceStatus === "Approved" || status.appvCreditInsuranceStatus === "Rejected" || status.appvCreditInsuranceStatus === "Management Approval")
            if (status.appvCreditInsuranceStatus !== "Pending") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
          } else if (approvalRole === "CEO") {
            if(status.appvCEOReq === "YES"){
                setApprovalReq("YES")
            }
            // if(status.mgmtAppvCEOReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if (status.appvCEOStatus === "Approved" || status.appvCEOStatus === "Rejected") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            if (status.mgmtAppvCEOStatus === "Approved" || status.mgmtAppvCEOStatus === "Rejected") {
              setMgmtResponse("Your Management Approval is already recorded for this Deal!");
              setShowMGMTThankYou(true);
            }
          } else if (approvalRole === "CFO") {
            if(status.appvCFOReq === "YES"){
                setApprovalReq("YES")
                
            }
            // if(status.mgmtAppvCFOReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if (status.appvCFOStatus === "Approved" || status.appvCFOStatus === "Rejected") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            if (status.mgmtAppvCFOStatus === "Approved" || status.mgmtAppvCFOStatus === "Rejected") {
              setMgmtResponse("Your Management Approval is already recorded for this Deal!");
              setShowMGMTThankYou(true);
            }
          } else if (approvalRole === "COO") {
            if(status.appvCOOReq === "YES"){
                setApprovalReq("YES")
            }
            // if(status.mgmtAppvCOOReq === "YES"){
            //     setMgmtApprovalReq("YES")
            // }
            if (status.appvCOOStatus === "Approved" || status.appvCOOStatus === "Rejected") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
            }
            if (status.mgmtAppvCOOStatus === "Approved" || status.mgmtAppvCOOStatus === "Rejected") {
              setMgmtResponse("Your Management Approval is already recorded for this Deal!");
              setShowMGMTThankYou(true);
            }
          } else if ( approvalRole === "SVP-Director") {
            if(status.appvSVPDirectorReq === "YES"){
                setApprovalReq("YES")
            }
            // && (status.appvSVPDirectorStatus === "Approved" || status.appvSVPDirectorStatus === "Rejected") 
            if (status.appvSVPDirectorStatus !== "Pending") {
            setResponse("Your approval is already recorded for this Deal!");
            setShowThankYou(true);
            }
          } else if ( approvalRole === "FUNCTIONAL HEAD") {

              let approverStatus = "";

              if (ApproversEmpId === status.appvFunctionalHeadID) {
                  setApprovalReq(status.appvFunctionalHeadReq)
              }else if (ApproversEmpId === status.appvFunctionalHead2ID) {
                  setApprovalReq(status.appvFunctionalHead2Req)
              }else if (ApproversEmpId === status.appvFunctionalHead3ID) {
                  setApprovalReq(status.appvFunctionalHead3Req)
              }else if (ApproversEmpId === status.appvFunctionalHead4ID) {
                  setApprovalReq(status.appvFunctionalHead4Req)
              }else if (ApproversEmpId === status.appvFunctionalHead5ID) {
                  setApprovalReq(status.appvFunctionalHead5Req)
              }else if (ApproversEmpId === status.appvFunctionalHead6ID) {
                  setApprovalReq(status.appvFunctionalHead6Req);
              }

              if (ApproversEmpId === status.appvFunctionalHeadID) {
                  approverStatus = status.appvFunctionalHeadStatus;
              }else if (ApproversEmpId === status.appvFunctionalHead2ID) {
                  approverStatus = status.appvFunctionalHead2Status;
              }else if (ApproversEmpId === status.appvFunctionalHead3ID) {
                  approverStatus = status.appvFunctionalHead3Status;
              }else if (ApproversEmpId === status.appvFunctionalHead4ID) {
                  approverStatus = status.appvFunctionalHead4Status;
              }else if (ApproversEmpId === status.appvFunctionalHead5ID) {
                  approverStatus = status.appvFunctionalHead5Status;
              }else if (ApproversEmpId === status.appvFunctionalHead6ID) {
                  approverStatus = status.appvFunctionalHead6Status;
              }


              if ( approverStatus === "Approved" || approverStatus === "Rejected") {
                  setResponse("Your approval is already recorded for this Deal!");
                  setShowThankYou(true);
              }
          } else if ( approvalRole === "LEGAL HEAD") {
            // && (status.appvLegalHeadStatus === "Approved" || status.appvlegalHeadStatus === "Rejected")
            if(status.appvLegalHeadReq === "YES"){
                setApprovalReq("YES")
            }
            if (status.appvLegalHeadStatus !== "Pending") {
            setResponse("Your approval is already recorded for this Deal!");
            setShowThankYou(true);
            }
          } else if ( approvalRole === "DYT-CFO") {
            if(status.appvDytCFOReq === "YES"){
                setApprovalReq("YES")
            }
            // && (status.appvDytCFOStatus === "Approved" || status.appvDytCFOStatus === "Rejected")
            if (status.appvLegalHeadStatus !== "Pending") {
            setResponse("Your approval is already recorded for this Deal!");
            setShowThankYou(true);
            }
          }
        })
        .catch((error) => {
          setError(error);
        });

      } catch (error) {
        console.error("Decryption error:", error);
      }
    
    }, [approvalRole, series]);


    const handleApprove = (e) => {

      if (approvalMessage === "") {
        e.preventDefault();
        let approvalStatus = "Approved";
        let approvalMessage = "Deal Approved";

        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalStatus = "Approved";
        
        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleReject = (e) => {
      if (rejectionMessage === "") {
        toast.error("Please provide a valid rejection reason ");
      } else {
        e.preventDefault();
        let approvalStatus = "Rejected";
        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Rejected:::::", response.data);
            setResponse("Thank you for your response!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleManagementApproval = (e) => {

      if (mgmtApprovalMessage === "") {
        e.preventDefault();

         if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }

        let approvalStatus = "Approved";
        let mgmtApprovalMessage = "Deal Approved";

        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setMgmtResponse("Thank you for your approval!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();

         if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }

        let approvalStatus = "Approved";
        
        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setMgmtResponse("Thank you for your approval!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleManagementReject = (e) => {
      if (mgmtRejectionMessage === "") {
        toast.error("Please provide a valid rejection reason for Management Approval");
      } else {
        e.preventDefault();

         if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }

        let approvalStatus = "Rejected";
        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Rejected:::::", response.data);
            setMgmtResponse("Thank you for your response!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleCreditInsuranceApproval = (e) => {

        if (approvalMessage === "") {
        e.preventDefault();
        let approvalStatus = "Management Approval";
        let appvCIMessage = "Credit Insurance Not Available Hence Submit For Management Approval";

        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalStatus = "Management Approval";
        
        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleRedirectToLogin = () => {
      navigate("/");
    };

    if (error) return <h1>Error: {error.message}</h1>;
    return (
      <Container className="pt-4 mb-4">
        {/* {  !showThankYou ? (
          <>
            <Col className="d-flex justify-content-center pt-5 mt-5">
              <h3>Please Provide Feedback</h3>
            </Col>
            <Row className="pt-4 justify-content-center">
                <InputGroup>
                  <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)} />
                  <Button variant="success" onClick={handleApprove}>Approve</Button>
                </InputGroup>
            </Row>
            <Row className="pt-4 justify-content-center">
              <InputGroup>
                <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)} />
                <Button variant="danger" onClick={handleReject}>Reject</Button>
              </InputGroup>
            </Row>
            {(approvalRole === 'CREDIT INSURANCE') && (<Row className="pt-4 justify-content-center">
              <InputGroup>
                <Form.Control type="text" placeholder="Management Approval Message" value={appvCIMessage} onChange={(e) => setAppvCIMessage(e.target.value)} />
                <Button variant="warning" onClick={handleCreditInsuranceApproval}>Management Approval Required</Button>
              </InputGroup>
            </Row>)}
          </>
        ) : (
          <div className="pt-5 mt-5">
            <Col className="d-flex justify-content-center pb-5">
              <h1 style={{ color: "Green" }}>{response}</h1>
            </Col>
            <Col className="d-flex justify-content-center">
              <p>Click below to login back to portal</p>
            </Col>
            <Col className="d-flex justify-content-center">
              <Button variant="primary" onClick={handleRedirectToLogin}> Login </Button>
            </Col>
          </div>
        )} */}
        {approvalReq === "YES" && (
          !showThankYou ? (
            <>
              <Col className="d-flex justify-content-center pt-5 mt-5">
                <h2>Please provide feedback for Enterprise CostSheet</h2>
              </Col>

              <Row className="pt-4 justify-content-center">
                <InputGroup>
                  <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)}/>
                  <Button variant="success" onClick={handleApprove}>Approve</Button>
                </InputGroup>
              </Row>

              <Row className="pt-4 justify-content-center">
                <InputGroup>
                  <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)}/>
                  <Button variant="danger" onClick={handleReject}>Reject</Button>
                </InputGroup>
              </Row>

              {approvalRole === "CREDIT INSURANCE" && (
                <Row className="pt-4 justify-content-center">
                  <InputGroup>
                    <Form.Control type="text" placeholder="Management Approval Message" value={appvCIMessage} onChange={(e) => setAppvCIMessage(e.target.value)}/>
                    <Button variant="warning" onClick={handleCreditInsuranceApproval}>Management Approval Required</Button>
                  </InputGroup>
                </Row>
              )}
            </>
          ) : (
            <div className="pt-5 mt-5">
              <Col className="d-flex justify-content-center pb-5">
                <h1 style={{ color: "green" }}>{response}</h1>
              </Col>

              <Col className="d-flex justify-content-center">
                <p>Click below to login back to portal</p>
              </Col>

              <Col className="d-flex justify-content-center">
                <Button variant="primary" onClick={handleRedirectToLogin}>
                  Login
                </Button>
              </Col>
            </div>
          )
        )}

        {mgmtApprovalRequire === "YES" && (
          !showMGMTThankYou ? (
          <>
            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Col className="d-flex flex-column align-items-center pt-5 mt-4">
              <h2>Please provide management feedback for Credit Insurance Risk</h2>
              <h5>(For Credit Insurance Check) Reason: <span style={{ fontWeight: 400, background: "lightcoral" }}>{ciMgmtReason}</span></h5>
            </Col>)}

            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
                <InputGroup>
                  <Form.Control type="text" placeholder="Management approval message" value={mgmtApprovalMessage} onChange={(e) => setMgmtApprovalMessage(e.target.value)} />
                  <Button variant="success" onClick={handleManagementApproval}>Approve</Button>
                </InputGroup>
            </Row>)}
            
            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
              <InputGroup>
                <Form.Control type="text" placeholder="Management rejection message" value={mgmtRejectionMessage} onChange={(e) => setMgmtRejectionMessage(e.target.value)} />
                <Button variant="danger" onClick={handleManagementReject}>Reject</Button>
              </InputGroup>
            </Row>)}
          </>
            ) : (<>
              {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<div className="pt-5 mt-5">
                <Col className="d-flex justify-content-center pb-5">
                  <h1 style={{ color: "Green" }}>{mgmtResponse}</h1>
                </Col>
              </div>)}
              </>

            )
        )}

        {/* {!showMGMTThankYou ? (
          <>
            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Col className="d-flex flex-column align-items-center pt-5 mt-4">
              <h2>Please Provide Management Feedback</h2>
              <h5> Reason: <span style={{ fontWeight: 400 }}>{ciMgmtReason}</span></h5>
            </Col>)}

            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
                <InputGroup>
                  <Form.Control type="text" placeholder="Management approval message" value={mgmtApprovalMessage} onChange={(e) => setMgmtApprovalMessage(e.target.value)} />
                  <Button variant="success" onClick={handleManagementApproval}>Approve</Button>
                </InputGroup>
            </Row>)}
            
            {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
              <InputGroup>
                <Form.Control type="text" placeholder="Management rejection message" value={mgmtRejectionMessage} onChange={(e) => setMgmtRejectionMessage(e.target.value)} />
                <Button variant="danger" onClick={handleManagementReject}>Reject</Button>
              </InputGroup>
            </Row>)}
          </>
        ) : (<>
          {(approvalRole === 'TEAM LEADER' || approvalRole === 'BRANCH HEAD' || approvalRole === 'REGION BUSINESS HEAD' || approvalRole === 'BUSINESS FINANCE' || approvalRole === 'CEO' || approvalRole === 'CFO' || approvalRole === 'COO') && (mgmtApprovalRequire === 'YES') && (<div className="pt-5 mt-5">
            <Col className="d-flex justify-content-center pb-5">
              <h1 style={{ color: "Green" }}>{mgmtResponse}</h1>
            </Col>
          </div>)}
          </>

        )} */}
      </Container>
    )
}

export default CostSheetApproval
